import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-view-search',
  templateUrl: './view-search.component.html',
  styleUrls: ['./view-search.component.scss']
})
export class ViewSearchComponent implements OnInit {
  searchList:[];
  searchlength:number;
  category:string;
  specialityId:string;
  userID:string;
 
  imgPlaceholder = './assets/images/noimage.png';
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) { 
      this.category = this.activatedRoute.snapshot.paramMap.get('category');
      this.specialityId = this.activatedRoute.snapshot.paramMap.get('specialityId');
    }

  ngOnInit() {

    
    let classSearchData = {

      lat: null,
      lang: null,
      serviceTypeID: this.category,
      specialityID: this.specialityId
    }

    this.apiService.classSearchList(classSearchData).subscribe((res:any)=>{      
      this.searchList = res.data.classBusinessData.data.businessDetails;
      this.searchlength = this.searchList.length;

    })

  }

  getShortName(fullName) {
    return fullName.charAt(0);
  }
  classprofile(venId,id){   
    this.router.navigateByUrl(`classprofile/`+venId + `/`+ id);
    
  }

}
